import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
`;

const WelcomeTitle = styled.h2`
  color: #183967;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  color: #183967;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
`;

const Text = styled.p`
  color: #111827;
  font-size: 15px;
  line-height: 1.75;
  text-align: justify;
  margin: 0 0 15px 0;
`;

const IntroText = styled.p`
  color: #111827;
  font-size: 15px;
  line-height: 1.7;
  margin: 15px 0;
`;

const InitiativeList = styled.ul`
  margin: 15px 0 20px;
  padding-left: 22px;
  list-style: disc;

  li::marker {
    color: #0b8f6b;
    font-size: 16px;
  }
`;

const InitiativeItem = styled.li`
  color: #111827;
  font-size: 15px;
  line-height: 1.65;
  margin-bottom: 14px;
  text-align: justify;

  strong {
    color: #183967;
    font-weight: 700;
  }
`;

const VisionMissionContent = () => {
  return (
    <Container>
      
      <Section>
        <SectionTitle>Our Mission</SectionTitle>

        <Text>
          To promote the economic empowerment and socio-economic upliftment of
          the weaker sections among minority communities by providing
          accessible and affordable financial assistance, fostering
          entrepreneurship, generating sustainable livelihood opportunities,
          and enabling inclusive growth. We are committed to supporting
          individuals, self-help groups, and small enterprises through
          concessional finance and development-oriented initiatives that
          enhance their economic independence and improve their quality of
          life.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Our Vision</SectionTitle>

        <Text>
          To create a financially inclusive and economically self-reliant
          minority community by facilitating access to credit, skill
          development, entrepreneurship opportunities, and market linkages. We
          envision a society where every individual from minority communities
          has the opportunity, resources, and support necessary to achieve
          sustainable growth and prosperity.
        </Text>

        <IntroText>
          Our vision is realised through the following key initiatives:
        </IntroText>

        <InitiativeList>
          <InitiativeItem>
            <strong>
              Promotion of Economic Activities through Concessional Finance:
            </strong>{" "}
            Providing affordable financial assistance to eligible
            beneficiaries for self-employment, micro-enterprises, small
            businesses, and income-generating activities.
          </InitiativeItem>

          <InitiativeItem>
            <strong>
              Vocational Training and Skill Development Programmes:
            </strong>{" "}
            Enhancing employability and entrepreneurial capacity by equipping
            individuals with industry-relevant skills, technical knowledge,
            and professional competencies.
          </InitiativeItem>

          <InitiativeItem>
            <strong>Marketing Support Initiatives:</strong> Assisting artisans,
            entrepreneurs, and small business owners in accessing wider
            markets, improving product visibility, and strengthening their
            competitiveness.
          </InitiativeItem>

          <InitiativeItem>
            <strong>Mahila Samridhi Yojana:</strong> Empowering women from
            minority communities through targeted financial support,
            entrepreneurship promotion, and income-generating opportunities
            that foster self-reliance and economic security.
          </InitiativeItem>

          <InitiativeItem>
            <strong>Awareness and Advocacy Programmes:</strong> Creating
            awareness about government schemes, financial literacy,
            entrepreneurship opportunities, and socio-economic development
            initiatives to ensure greater participation and informed
            decision-making among beneficiaries.
          </InitiativeItem>
        </InitiativeList>

        <Text>
          Through these efforts, we strive to build an empowered, skilled, and
          economically prosperous minority community that contributes
          meaningfully to the nation's overall growth and development.
        </Text>
      </Section>
    </Container>
  );
};

export default VisionMissionContent;
